export default __webpack_public_path__ + "static/media/bottom-tabs-specs.208b783e.png";